import { createSelector } from 'reselect';
import { reduxKey } from './constants';
export const getConfig = (state)=>state[reduxKey] || {};
export const getConfigKey = createSelector(getConfig, (_, name)=>name, (configState, name)=>{
    return configState[name];
});

//# sourceMappingURL=selectors.js.map